import { Button } from '../components/button.jsx';
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog.jsx';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { useState, useEffect, useCallback } from 'react';
import config from '../config.js';

export default function PerformanceChangeHistory({ isOpen, setIsOpen, productId, testCycleId }) {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const getHistoryData = useCallback(async () => {
    if (!productId || !testCycleId) return;

    try {
      setLoading(true);
      const response = await fetch(`${config.apiPath}/performance_process/performance_change_history.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: productId,
          test_cycle_id: testCycleId
        }),
      });

      const data = await response.json();

      if (data.status === 'success') {
        const records = data.records ? Object.values(data.records) : [];
        setHistoryData(records);
      } else {
        console.error('Failed to fetch history data:', data.errMsg);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    } finally {
      setIsDataLoaded(true);
      setLoading(false);
    }
  }, [productId, testCycleId]);

  useEffect(() => {
    if (isOpen) {
      getHistoryData();
    }
  }, [isOpen, getHistoryData]);

  return (
    <Dialog open={isOpen} onClose={setIsOpen} size="5xl">
      <DialogTitle>Product Change History - {productId}</DialogTitle>
      <DialogDescription>View the history of changes for this product.</DialogDescription>

      <DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
        {!loading && isDataLoaded && historyData.length === 0 && (
          <p className="text-sm text-gray-500 dark:text-gray-400">
            No change history found for this product.
          </p>
        )}

        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                      <div className="loader border-4 border-black-500 border-t-transparent rounded-full w-6 h-6 animate-spin" />
                    </div>
        )}

        {!loading && historyData.length > 0 && (
          <div className="text-sm">
            <Table>
            <TableHead>
            <TableRow>
                  <TableHeader>Permutations</TableHeader>
                  <TableHeader>Edited by</TableHeader>
                  <TableHeader className="whitespace-normal break-words">From</TableHeader>
                  <TableHeader>To</TableHeader>
                  <TableHeader>Date</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyData.map((item, idx) => ( 
                  <TableRow key={idx}>
                    <TableCell>{item.permuations}</TableCell>
                    <TableCell>{item.user_id}</TableCell>
                    <TableCell  className="whitespace-normal break-words">{item.from}</TableCell>
                    <TableCell  className="whitespace-normal break-words">{item.to}</TableCell>
                    <TableCell>{item.created_on ? new Date(item.created_on).toLocaleString() : '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </DialogBody>

      <DialogActions>
        <Button plain onClick={setIsOpen}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
